<div class="rm-header">
  <span>Investor Details</span>
</div>
<!--form-->
<form [formGroup]="userForm" (ngSubmit)="submit()">
  <mat-dialog-content>
    <h2>{{data.businessUnit?.displayName}}</h2>

    <div class="row" style="padding-bottom: 10px;">
      <div class="col-12 col-md-3">
        <span style="font-weight: lighter; min-width: 250px;">Employees:</span>
      </div>
      <div class="col-12 col-md-9">
        <div *ngFor="let admin of data?.businessUnitEmployees" style="display: inline-flex;">
          <div class="pill"
                [class]="(admin?.firstName != '') && (admin?.lastName != '') ? 'grey-pill' : 'yellow-pill'"
                (click)="view(admin)">
            <span>{{(admin?.firstName != '') && (admin?.lastName != '') ? (admin.firstName + ' ' + admin.lastName) : admin?.email}}</span>
          </div>
        </div>
      </div>
    </div>
    <!--        row start-->
    <div class="row" style="padding-bottom: 10px;">
      <div class="col-12 col-md-3">
        <span style="font-weight: lighter;">Users On the Deal Team:</span>
      </div>
      <div class="col-12 col-md-9">
        <div *ngFor="let user of data?.dealTeamMembers" style="display: inline-flex;">
          <div class="pill"
                [class]="(user?.firstName != '') && (user?.lastName != '') ? 'grey-pill' : 'yellow-pill'"
                (click)="view(user)">
            <span>{{(user?.firstName != '') && (user?.lastName != '') ? (user.firstName + ' ' + user.lastName) : user?.email}}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="row pt-3">
      <div class="col-12">
        <b>Investor has Signed Deal-by-deal NDA</b>
        <br />
        <mat-checkbox formControlName="isDealNdaSigned" color="primary">
          <!-- NDA is Signed <br /> -->
          <em>If this box is checked, then the Investor is deemed to have signed the Deal-by-deal NDA on this deal only.</em>
        </mat-checkbox>
      </div>

      <div class="col-12 mt-4">
        <b>Investor has Signed Issuer's Own NDA</b>
        <br />
        <mat-checkbox formControlName="isIssuerNdaSigned" color="primary">
          <!-- NDA is Signed <br /> -->
          <em>
            If this box is checked, then the Investor is deemed to have signed the Issuer's own NDA requirement on this deal.
            This only applies to deals where the Issuer also requires the Investor to sign their NDA before Rondeivu can show them the offering details.

          </em>
        </mat-checkbox>
      </div>

      <div class="col-12 mt-4 mb-3">
        <b>Investor Workflow Status</b>
        <br/>
        <mat-form-field class="form-field" appearance="outline">
          <mat-select id="status" formControlName="investorWorkflowStatus">
            <mat-option *ngFor="let c of lookupService.lookups.investorDealWorkflowStatus" [value]="c.key">
              {{c.value}}
            </mat-option>
          </mat-select>
          <mat-hint align="end">If the investor has declined the deal, this status will change</mat-hint>
        </mat-form-field>
      </div>


    </div>

  </mat-dialog-content>

  <div mat-dialog-actions align="center" class="justify-content-between">
    <button mat-button type="button" mat-dialog-close>Cancel</button>
    <button mat-raised-button color="primary" type="submit">Save</button>
  </div>
</form>

